/**
 * Fila de 3 KPIs de la pestaña Estadísticas del cotizador (presentacional).
 *
 * Réplica de los `stats-kpi` del SSR (`cotizador_puertas.html`): LO QUE TE QUEDA
 * (ganancia neta), LO QUE PAGAS (costo material) e IVA (19% base material). Sin lógica de
 * datos: recibe la última cotización y formatea lo que la API ya calculó. Mismo lenguaje
 * visual que `features/stats/StatsKpis` (Card + label en versalitas + valor grande).
 */
import { Card, CardContent } from "@/components/ui";

import { formatMoney } from "../format";
import type { CalcResult } from "../types";

interface StatsKpiRowProps {
  /** Última cotización calculada (su `stats_desktop` alimenta los KPIs). */
  calc: CalcResult;
}

interface KpiProps {
  label: string;
  value: string;
  /** Tono del valor según su naturaleza (ganancia/costo/impuesto). */
  tone: "profit" | "cost" | "tax";
}

const TONE_CLASS: Record<KpiProps["tone"], string> = {
  profit: "text-emerald-600",
  cost: "text-cyan-600",
  tax: "text-amber-600",
};

function Kpi({ label, value, tone }: KpiProps) {
  return (
    <Card>
      <CardContent className="flex flex-col gap-1 py-4">
        <span className="text-xs font-semibold uppercase tracking-[0.08em] text-slate-500">
          {label}
        </span>
        <span className={`text-2xl font-bold ${TONE_CLASS[tone]}`}>{value}</span>
      </CardContent>
    </Card>
  );
}

export function StatsKpiRow({ calc }: StatsKpiRowProps) {
  const stats = calc.stats_desktop;
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
      <Kpi
        label="Lo que te queda (ganancia neta)"
        value={formatMoney(stats?.ganancia_total)}
        tone="profit"
      />
      <Kpi
        label="Lo que pagas (costo material)"
        value={formatMoney(stats?.costo_real_lam)}
        tone="cost"
      />
      <Kpi label="IVA (19% base material)" value={formatMoney(stats?.iva_total)} tone="tax" />
    </div>
  );
}
